export enum Keys {
    ArrowDown = 'ArrowDown',
    ArrowUp = 'ArrowUp',
    Backspace = 'Backspace',
    Enter = 'Enter',
    Escape = 'Escape',
    Tab = 'Tab',
};